import { FC } from 'react';

interface ScrollArrowProps {
  direction: 'left' | 'right';
  onClick: () => void;
  hidden?: boolean;
}

const ScrollArrow: FC<ScrollArrowProps> = ({ direction, onClick, hidden }) => {
  const isLeft = direction === 'left';

  return (
    <button
      type="button"
      className={`trending-feed-arrow trending-feed-arrow-${direction}`}
      onClick={onClick}
      aria-label={`Scroll ${direction}`}
      style={{ visibility: hidden ? 'hidden' : 'visible' }}
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
        <path
          d={isLeft ? 'M10.5 12.5L6 8l4.5-4.5' : 'M5.5 3.5L10 8l-4.5 4.5'}
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
        />
      </svg>
    </button>
  );
};

export default ScrollArrow;
